import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { styled } from "@mui/material/styles";
import ButtonBase from "@mui/material/ButtonBase";
import Tooltip from "@mui/material/Tooltip";
import SportrecsLogoIcon from "core/components/SportrecsLogoIcon";

const LogoButtonBase = styled(ButtonBase)(({ theme }) => ({
  padding: 6,
  color: "rgb(255, 255, 255)",
  borderRadius: 4,

  "@media (max-width: 450px)": {
    padding: 4,
  },

  [theme.breakpoints.up("sm")]: {
    padding: 10,
  },

  [theme.breakpoints.up("md")]: {
    padding: 12,
  },

  // Убираем все hover эффекты
  "&:hover": {
    backgroundColor: "transparent",
  },
  "&.Mui-focusVisible": {
    backgroundColor: "transparent",
  },
}));

const ArenaLogo = styled("img")({
  height: 24,
  width: "auto",
  maxWidth: 120,
  objectFit: "contain",
});

function LogoButton({ url, arena }) {
  const { t } = useTranslation("core");

  // Используем embedLogo, если задан, иначе обычный logo
  const logoUrl = arena?.embedLogo?.url || arena?.logo?.url;

  const logoElement = logoUrl ? (
    <ArenaLogo src={logoUrl} alt="Arena logo" />
  ) : (
    <SportrecsLogoIcon />
  );

  // Формируем текст для tooltip
  const tooltipText = arena?.title
    ? `Перейти на ${arena.title}`
    : t("logoButton");

  return (
    <Tooltip title={tooltipText} placement="top-end" arrow>
      <LogoButtonBase component="a" href={url} target="_blank" rel="noopener">
        {logoElement}
      </LogoButtonBase>
    </Tooltip>
  );
}

LogoButton.propTypes = {
  url: PropTypes.string.isRequired,
  arena: PropTypes.shape({
    title: PropTypes.string,
    logo: PropTypes.shape({
      url: PropTypes.string,
    }),
    embedLogo: PropTypes.shape({
      url: PropTypes.string,
    }),
  }),
};

export default LogoButton;
